enum SDCTextFieldSize {
  Default,
  Small,
}

export default SDCTextFieldSize;
